<!-- 基础属性排序 -->
<template>
    <div v-loading="loading">
        <div class="set-content">
            <draggable v-model="attrDatas">
                <div v-for="item in attrDatas" :key="item.Id">
                    <div class="set-item">
                        <el-tag class="item-cname2" effect="plain">
                            {{ item.AttrName }}
                        </el-tag>
                    </div>
                </div>
            </draggable>
        </div>
        <div slot="footer" class="dialog-footer" style="text-align: right; margin-top: 20px; padding-bottom: 10px">
            <el-button class="search-btn" @click="closeDialog()">取消</el-button>
            <el-button class="search-btn btn-primary" @click="submit">保存排序</el-button>
        </div>
    </div>
</template>
<script>
import draggable from 'vuedraggable';
export default {
    props: ['attrDatas', 'attrCode'],
    name: 'attrSort',
    components: {
        draggable
    },
    data() {
        return {
            loading: false,
            separatorObj: {}
        };
    },
    created() {
        // 阻止火狐的默认拖拽事件
        document.body.ondrop = event => {
            event.preventDefault();
            event.stopPropagation();
        };
    },
    mounted() {
        if (!this.attrDatas) {
            this.$util.warningMsg('要排序的属性数据异常，请刷新后重新操作');
        }
    },
    methods: {
        submit() {
            this.loading = true;
            // 重新排序
            let dataSort = this.attrDatas.map((m, i) => {
                return Object.assign(m, { SortNum: i + 1 });
            });
            this.$util
                .axiosPost({
                    url: '/api/EntpInfoManagement/SubmitAttrSort',
                    data: { AttrSort: dataSort, AttrCode: this.attrCode },
                    hideLoading: true
                })
                .then(res => {
                    this.$util.successMsg(res.errmsg);
                    this.$emit('closeDialog', true);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        closeDialog() {
            this.$emit('closeDialog');
        }
    }
};
</script>
<style lang="less" scope>
.set-content {
    display: flex;
    flex-direction: column;

    .set-item {
        display: flex;
        flex-direction: row;
        height: 40px;

        .item-cname2 {
            width: 100% !important;
        }
    }
    .el-input-group__prepend {
        padding: 0 10px;
        border-radius: 0;
    }
    .el-input-group__append {
        padding: 0 10px;
    }
    .el-tag {
        height: 100%;
        width: 100%;
        border-radius: 5px;
        font-size: 14px;
        line-height: 35px;
    }
}
</style>
